import { trpc } from '@/shared/api/trpc';

const ONE_MINUTE = 60 * 1000;

type FilterCountsRange = {
  startDate?: string;
  endDate?: string;
};

// Opt out of batching: the toolbar filter counts aggregate over the
// operations view and shouldn't gate the `operations.list` request in the
// same batch. Render the list first; the dropdown counts fill in after.
// Prefer the page date range so facet counts match the list window (not a
// fixed 7-day default). Server keeps a short process-local cache keyed by
// org + range; mutations/SSE invalidate it.
export const useOperationFilterCountsData = (range?: FilterCountsRange) =>
  trpc.operations.filterCounts.useQuery(
    {
      startDate: range?.startDate,
      endDate: range?.endDate,
    },
    {
      staleTime: ONE_MINUTE,
      trpc: { context: { skipBatch: true } },
    }
  );
